import _ from 'lodash-es';

// 检查域名是否包含某字符串
export const checkUrlWoa = () => {
  const urlStr = window.location.href;
  let isHasWoa = false;
  if (_.isEmpty(urlStr)) return false;
  // 安全域名
  const woaUrl = 'databrain.woa.com';
  const regexp = new RegExp(`^(http://|https://){1}(\\w*)(\\.)*${woaUrl}`, 'i'); // 正则表达式
  const res = regexp.exec(urlStr); // 执行匹配，并获取到匹配结果
  if (!_.isEmpty(res)) {
    isHasWoa = true;
  }
  return isHasWoa;
};
